import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Observable, empty, of, throwError } from 'rxjs';
import { BaseConfig } from 'src/app/services/base-config.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserCache } from 'src/app/services/user-cache';
import { WebApiClient } from 'src/app/services/web-api-client.service';
import { WebApiService } from 'src/app/services/web-api.service';
import { Clinic } from 'src/app/system/clinic/models/clinic';
import { CryptoService } from 'src/app/services/crypto-service';
import { UserApi } from 'src/app/services/api-service/user/user-api';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { ValueTextPair } from 'src/app/shared/models/value-text-pair';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class MigrateToolService {
  // 系統參數
  private count = 0;
  private timer: any;
  private loginToken = '';
  private api: WebApiService;

  logoutEvent = new EventEmitter();
  constructor(private http: HttpClient,
    private webApiFactory: WebApiClient) {
      this.api = this.webApiFactory.createHisService('api/migration');
  }
  
  async login(companyCode: string, user: string,pwd: string): Promise<boolean> {
    var ret = await this.api.get('Login',{companyCode:companyCode,user,pwd}).toPromise<{token:string}>();
    if(ret.token){
      this.loginToken = ret.token;
    }
    return !!ret.token;
  }
  async checkDataCount(companyCode: string,clinicId:number): Promise<string> {
    
    var ret =  await this.api.get('CheckDataCount',{companyCode,clinicId}).toPromise<{msg:string}>();
    return ret.msg;
  }
  getOrganizes(): Promise<ValueTextPair[]> {
    return this.api.get('getOrganizes').toPromise<ValueTextPair[]>();
  }
  getProgress(companyCode: string): Promise<MigrationProgress> {
    if(!this.loginToken){
      alert('需先登入!')
      return null;
    }
    return this.api.get('GetProgress',{companyCode:companyCode,loginToken:this.loginToken}).toPromise<MigrationProgress>();
  }
  // cancel(companyCode: string, account: string): Promise<MigrationProgress> {
  //   return this.api.get('GetProgress',{companyCode:companyCode}).toPromise<MigrationProgress>();
  // }
  async createDb(companyCode: string): Promise<string> {
    if(!this.loginToken){
      alert('需先登入!')
      return '需先登入!';
    }
    return await this.api.get('CreateDb',{companyCode:companyCode,loginToken:this.loginToken}).toPromise<string>();
  }
  async setReady(companyCode: string,ready:boolean): Promise<boolean> {
    if(!this.loginToken){
      alert('需先登入!')
      return false;
    }
    return await this.api.get('setReady',{companyCode:companyCode,loginToken:this.loginToken,ready}).toPromise<boolean>();
  }
  async deleteDb(companyCode: string): Promise<string> {
    if(!this.loginToken){
      alert('需先登入!')
      return '需先登入!';
    }
    return await this.api.get('deleteDb',{companyCode:companyCode,loginToken:this.loginToken}).toPromise<string>();
  }

  // onAutoLogoutTimer() {
  //   var exp = UserCache.getLoginUser().ExpiresOn;
  //   const expiredOn = new Date(exp);
  //   let ms = expiredOn.getTime() - new Date().getTime();
  //   // 如果local的expiredOn過期, 5秒後更新
  //   if (ms <= 0) {
  //     ms = 5000;
  //   }
  //   // 再expiredOn的時間左右去更新expiredOn
  //   this.timer = setTimeout(() => {
  //     this.updateToken().subscribe(r => {
  //       // 更新成功等待下次檢查
  //       if (r) {
  //         this.onAutoLogoutTimer();
  //       } else {
  //         // 更新失敗(找不到token)則直接登出
  //         this.logout();
  //       }
  //     }, error => {
  //       this.logout();
  //     });
  //   }, ms);
  // }
}

export class MigrationProgress{
  State:string;
  Message:string;
  ConnectionString:string;
  OperationState:
  {
      Operation:string;
      PercentComplete:number;
      ErrorDescription:string;
      StartOn:Date;
  }[]
}